<template>
<span
  class="icon-box pointer"
  @click="startUsingHandle"
>
          <i class="el-icon-plus"></i>
</span>
</template>

<script>
import {addTradingCycle} from "@/api/copy";

export default {
  name: "startBtn",
  props: {
    mtId: {},
  },
  methods: {
    startUsingHandle(){
      this.$confirm(this.$t('startBeforeTips'), this.$t('startBeforeTipsTitle'), {
        confirmButtonText: this.$t('root.confirm'),
        cancelButtonText: this.$t('root.cancle'),
        type: 'warning',
        customClass: 'self-messagebox-wrapper'
      }).then(() => {
        addTradingCycle({
          mtId: this.mtId,
        }).then((res) => {
          this.$message({
            message: this.$t('Successfully_activated'),
            type: 'success'
          });
          this.$emit('startUsing-success');
        })
      }).catch(() => {
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-box {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #D8D6DE;
  color: #D8D6DE;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
</style>
